import React, { useMemo } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { RequestsPerCategory } from '../../codegen/graphql';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);

export const options = {
    indexAxis: 'y' as const,
    elements: {
        bar: {
            borderWidth: 2,
        },
    },
    responsive: true,
    plugins: {
        legend: {
            display: false,
        },
    },
    scales: {
        x: {
            border: {
                display: false,
            },
            grid: {
                display: false,
            },
            ticks: {
                display: false,
            },
        },
        y: {
            border: {
                display: false,
            },
            grid: {
                display: false,
            },
        },
    },
};

type Props = {
    requestsPerType: RequestsPerCategory[];
};

function RequestsPerTypeGraph({ requestsPerType }: Props) {
    const labels = useMemo(() => {
        return requestsPerType.map(requestPerType => {
            return requestPerType.category?.name;
        });
    }, [requestsPerType]);

    const data = useMemo(() => {
        return {
            labels,
            datasets: [
                {
                    label: 'Decrease',
                    data: requestsPerType.map(
                        ({ decreaseRequests }) => decreaseRequests,
                    ),
                    borderColor: 'orange',
                    backgroundColor: 'orange',
                    stack: '1',
                },
                {
                    label: 'Increase',
                    data: requestsPerType.map(
                        ({ increaseRequests }) => increaseRequests,
                    ),
                    borderColor: '#004d94',
                    backgroundColor: '#004d94',
                    stack: '1',
                },
                {
                    label: 'Total',
                    data: requestsPerType.map(
                        ({ totalRequests }) => totalRequests,
                    ),
                    borderColor: '#f2f3f5',
                    backgroundColor: '#f2f3f5',
                },
            ],
        };
    }, [requestsPerType]);

    const hasData = useMemo(() => {
        let allData: number[] = [];
        data?.datasets?.forEach(({ data: _data }) => {
            allData = [...allData, ..._data];
        });
        return !!allData.length;
    }, [data]);

    return (
        <div className="flex flex-1 h-[calc(100%)] p-5">
            {hasData ? (
                <Bar options={options} data={data} />
            ) : (
                <div className="flex justify-center items-center h-96">
                    No requests per type
                </div>
            )}
        </div>
    );
}

export default RequestsPerTypeGraph;
